var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.wrapper},[_vm._v("\n  "+_vm._s(_vm.message)+"\n  "),_c('base-button',{on:{"click":function($event){return _vm.$emit('update')}}},[_vm._v("\n    "+_vm._s(_vm.$trlMessage('dictionaries.reload'))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }